import { z } from 'zod';

// One row of the super-admin pricing grid: a tenant × an offered API, with the
// resolved Studio price (credits/call). Mirrors backend TenantApiPriceRowDto.
export const tenantApiPriceRowSchema = z.object({
  tenantId: z.string(),
  tenantName: z.string(),
  category: z.string(),
  tag: z.string(),
  apiName: z.string(),
  operationId: z.string(),
  consoleApiType: z.number(),
  price: z.number().nullable(),
  // Tolerate an older API build that doesn't send this yet (defaults to null →
  // no strike-through) so the page never hard-fails when backend is behind.
  defaultPrice: z.number().nullable().default(null),
  isPriceSet: z.boolean(),
  lastSyncedAt: z.string().nullable(),
});

export type TenantApiPriceRow = z.infer<typeof tenantApiPriceRowSchema>;

// Outcome of a "Refresh from Console" run. Mirrors backend PricingSyncResultDto.
export const pricingSyncResultSchema = z.object({
  tenantsSynced: z.number(),
  tenantsSkipped: z.number(),
  pricesUpserted: z.number(),
  missingPrices: z.number(),
  syncedAt: z.string(),
});

export type PricingSyncResult = z.infer<typeof pricingSyncResultSchema>;
